import {  memo , useCallback } from 'react';
import Grid from '@mui/material/Grid';
import Header from "../components/Header";
import { useTranslation } from "react-i18next";
import Insta360 from "../components/modal/insta360.js";
import { useLocation , useNavigate } from "react-router-dom"

const Insta360Modal = memo(() => {
    const { t } = useTranslation();
    const location = useLocation()
    const { link360 , returnUrl} = location.state;
    const navigate = useNavigate();

    const modalClose = useCallback((url) => {
        navigate(url);
    },[]);

    return (
        <>
        <Header 
          display={true} 
          title={t("360image.title")} 
          isList={false} />
        <Grid container justifyContent="center" alignItems="center" direction="column">
 
        {<Insta360 isOpen={true} modalClose={() => modalClose(returnUrl)} url={link360}></Insta360>}
        </Grid>
        </>
    )
});
export default Insta360Modal